module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row col-md-12"
  }, [_c('div', {
    staticClass: "col-md-3 col-md-push-9"
  }, [_c('h1', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_vm._v(_vm._s(_vm._f("capitalize")(_vm.$t('pesquisa'))))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pesquisa),
      expression: "pesquisa"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('placeholder_pesquise_por_nome')
    },
    domProps: {
      "value": (_vm.pesquisa)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pesquisa = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9 col-md-pull-3"
  }, [_c('div', [_c('h1', [_vm._v(_vm._s(_vm.$tc('autor', 2)) + " "), _c('small', [_vm._v("(" + _vm._s(_vm.autores_pesquisa.length) + "/" + _vm._s(_vm.autores.length) + ")")])]), _vm._v(" "), (_vm.pesquisa === '') ? _c('div', {
    staticClass: "letra-parent",
    staticStyle: {
      "margin-top": "10px",
      "margin-bottom": "20px"
    }
  }, _vm._l((_vm.letras), function(l) {
    return _c('div', {
      staticClass: "letra",
      class: {
        'letra-selected': _vm.letra == l
      },
      on: {
        "click": function($event) {
          _vm.letra = l
        }
      }
    }, [_vm._v("\n            " + _vm._s(_vm._f("upper")(l)) + "\n          ")])
  })) : _vm._e()]), _vm._v(" "), _c('div', [(_vm.autores_pesquisa.length === 0) ? _c('div', [(_vm.pesquisa !== '' || !_vm.letra) ? _c('span', [_vm._v(_vm._s(_vm.$t('nenhuma_pessoa_encontrada')))]) : _c('span', [_vm._v(_vm._s(_vm.$t('nenhuma_pessoa_encontrada_com_letra', {
    letra: _vm.letra.toUpperCase()
  })))])]) : _c('div', _vm._l((_vm.autores_pesquisa), function(a) {
    return _c('router-link', {
      key: a.id,
      staticClass: "a",
      attrs: {
        "to": '/autor/' + a.id
      }
    }, [_c('div', {
      staticClass: "a-nome",
      staticStyle: {
        "line-height": "100%",
        "font-size": "25px"
      }
    }, [_vm._v(_vm._s(a.nome))]), _vm._v(" "), _c('div', {
      staticClass: "a-instituicao"
    }, [_vm._v(_vm._s(a.instituicao))]), _vm._v(" "), _c('div', {
      staticClass: "a-infos"
    }, [_c('div', {
      staticClass: "a-info"
    }, [_c('b', [_vm._v(_vm._s(a.todos_trabalhos.length))]), _vm._v("\n                " + _vm._s(_vm.$tc('publicacao', a.todos_trabalhos.length)) + "\n              ")]), _vm._v(" "), _c('div', {
      staticClass: "a-info"
    }, [_c('b', [_vm._v(_vm._s(a.eixos.length))]), _vm._v(" " + _vm._s(_vm.$tc('eixo_tematico', a.eixos.length)))])])])
  }))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b96ae2b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/anais/AnaisAutores.vue
// module id = 209
// module chunks = 0